<main class="w-100 h-100 relative overflow-x-hidden overflow-y-hidden">
  <iframe [src]="currentPath" frameborder="0" class="w-100 h-100"></iframe>
</main>
